import api from "@/lib/api";

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

function urlB64ToUint8(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function enablePush(ask = true) {
  if (!pushSupported()) return false;
  const perm = ask ? await Notification.requestPermission() : Notification.permission;
  if (perm !== "granted") return false;
  const reg = await navigator.serviceWorker.register("/push-sw.js", { updateViaCache: "none" });
  reg.update().catch(() => {});
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8(data.key) });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return true;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration("/push-sw.js");
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
}

let ctx;
function getCtx() {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

if (typeof window !== "undefined") {
  const unlock = () => {
    try {
      const c = getCtx();
      const b = c.createBuffer(1, 1, 22050);
      const s = c.createBufferSource();
      s.buffer = b; s.connect(c.destination); s.start(0);
    } catch (_) {}
  };
  ["pointerdown", "touchstart", "keydown"].forEach((ev) => window.addEventListener(ev, unlock, { passive: true }));
}

// Whistle "fiu-fiuu": two rising sweeps
export function playDing() {
  try {
    const c = getCtx();
    const t = c.currentTime;
    [[0, 0.18, 1400, 2600], [0.24, 0.32, 1400, 3000]].forEach(([start, dur, f1, f2]) => {
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(f1, t + start);
      o.frequency.exponentialRampToValueAtTime(f2, t + start + dur);
      g.gain.setValueAtTime(0.0001, t + start);
      g.gain.exponentialRampToValueAtTime(0.45, t + start + 0.03);
      g.gain.setValueAtTime(0.45, t + start + dur - 0.05);
      g.gain.exponentialRampToValueAtTime(0.0001, t + start + dur);
      o.connect(g).connect(c.destination);
      o.start(t + start);
      o.stop(t + start + dur + 0.02);
    });
  } catch (_) {}
  if (navigator.vibrate) navigator.vibrate([150, 80, 250]);
}
